/**
 * Mobile sticky action bar for the predictions page.
 * Shows pending-prediction count and points at stake; manual "Salvar tudo"
 * is a no-op when autosave is enabled (autosave handles it). Visible on
 * mobile only — desktop has the per-card Save button.
 */

import { Target } from 'lucide-react';
import { cn } from '../../lib/utils';

export interface PredictionStickyBarProps {
  pendingCount: number;
  totalAtStake?: number;
  className?: string;
}

export default function PredictionStickyBar({
  pendingCount,
  totalAtStake,
  className,
}: PredictionStickyBarProps) {
  if (pendingCount === 0) return null;
  return (
    <div
      className={cn(
        'sm:hidden',
        'fixed inset-x-0 bottom-0 z-40 safe-bottom',
        'border-t border-border',
        'bg-background/95 backdrop-blur-md',
        'shadow-[0_-4px_16px_rgba(0,0,0,0.06)] dark:shadow-[0_-4px_16px_rgba(0,0,0,0.4)]',
        'px-4 py-3',
        className
      )}
      role="region"
      aria-label="Resumo de palpites pendentes"
    >
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-500/20 text-primary-700 dark:text-primary-300">
          <Target className="h-4 w-4" aria-hidden="true" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground">
            {pendingCount} {pendingCount === 1 ? 'palpite pendente' : 'palpites pendentes'}
          </p>
          {totalAtStake !== undefined && totalAtStake > 0 && (
            <p className="text-xs text-muted-foreground">
              Até {totalAtStake} {totalAtStake === 1 ? 'ponto' : 'pontos'} em jogo
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
